//@config
export default {
  survey: {
    survey_group: "v1/survey_group",
    survey_group_azmoon: "v1/survey_group/{0}/azmoon",
    survey_group_azmoon_combo: "v1/survey_group/{0}/azmoon_combo",
    azmoon_execute_combo: "v1/azmoon_execute_combo",
    survey_group_parvandeh: "v1/survey_group/{0}/parvandeh",
    survey_group_parvandeh_combo: "v1/survey_group/{0}/parvandeh_combo",
    survey_group_parvandeh_relation:
      "v1/survey_group_parvandeh_relation/{0}/limit",
    all_survey: "v1/all_survey",
    my_survey: "v1/my_survey",
    mySurveyGroup: "v1/my-survey-group",
    survey_available_parvandeh_combo: "v1/survey_group/{0}/available_parvandeh",
    survey: "v1/survey",
    parvandeh_combo: "v1/parvandeh_combo",
    womenInfluence: "v1/women-influence",
    surveyGroupTerm: "v1/survey_group/{0}/term",
    womenInfluenceConfirm: "v1/women-influence-confirm",
    mySurveyGroupParvandeh: "v1/my-survey-group/{0}/parvandeh",
    survayGroupImport: "v1/survey-groups/{0}/import-parvandeh",
  },
};
